/**
 * Time source shared by the splat swap transition scripts (dissolve, wipe).
 *
 * Normally a transition advances with the engine's frame time. While `manual` is set (a video
 * capture), the engine tick leaves it alone and the owner steps it with the script's
 * `advance(dtSec)` by the video's frame time instead, so a dissolve lasts as many video frames
 * as it lasts seconds live, on any machine and in a background tab.
 */
export interface TransitionClock {
    manual: boolean;
}

/** Progress within this much of the end counts as the end (frame times add up inexactly). */
export const TRANSITION_END_EPSILON = 1e-6;

/** effectTime after adding dt, snapped onto `duration` when floating-point sums fall just short. */
export function stepEffectTime(effectTime: number, dt: number, duration: number): number {
    const next = effectTime + dt;
    return duration - next <= duration * TRANSITION_END_EPSILON ? Math.max(next, duration) : next;
}
